module.exports = __webpack_public_path__ + "assets/images/pages/job/image-detail-1.png?de542fbe";